import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import { categories, getMoviesByCategory } from '@/mocks/movies';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'tv-series');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);
  const movies = getMoviesByCategory(activeSlug);

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${currentCategory?.name || '分类'} - 大师兄影视`,
            description: `大师兄影视${currentCategory?.name || '影视'}分类，高清免费在线观看，海量${currentCategory?.name || '影视'}资源一网打尽，不缓冲秒开播放。`,
            url: `https://www.dashixiong.tv/category/${activeSlug}`,
          }),
        }}
      />

      <Navbar />

      <main className="pt-20 pb-12">
        <div className="w-full px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: currentCategory?.name || '分类' },
            ]}
          />

          <div className="mt-6">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading">
              {currentCategory?.name}
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              共 {movies.length} 部{currentCategory?.name}作品
            </p>
          </div>

          {/* Category Tabs */}
          <div className="mt-6 flex items-center gap-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-950'
                    : 'bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200 border border-background-200'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Movie Grid */}
          <div className="mt-8">
            {movies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
                {movies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-500"></i>
                </div>
                <p className="text-foreground-500">暂无该分类的影视内容</p>
                <Link
                  to="/"
                  className="inline-flex items-center gap-1.5 mt-4 px-5 py-2.5 bg-primary-500 text-background-950 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}